import { LANG } from '@/store'
import type { CHIP_KEY, CHIP_ENCRYPTED_ID } from './config'
import type { REWARD_KEY } from './config.reward'

export interface IChipData {
  _id: CHIP_KEY
  encryptedId: CHIP_ENCRYPTED_ID
  order: number
  title: string
  description: {
    [LANG.EN]: string
    [LANG.TH]: string
  }
  color: string
  position: {
    lat: number
    lng: number
  }
}

export interface IUserChipData {
  _id: CHIP_KEY
  createdAt: number
}

export type TUserReward = `${REWARD_KEY}` | REWARD_KEY | 'NULL'

export enum RESPONSE_LEVEL {
  WARN = 'WARN',
  FAIL = 'FAIL',
  ERROR = 'ERROR',
}

export enum RESPONSE_CASE {
  NO_SESSION = 'NO_SESSION',
  NO_USER = 'NO_USER',
  ALREADY = 'ALREADY',
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
  ERROR = 'ERROR',
}

export enum TOAST_CASE {
  COLLECT_SUCCESS = 'COLLECT_SUCCESS',
  COLLECT_FAILED = 'COLLECT_FAILED',
  ALREADY_COLLECTED = 'ALREADY_COLLECTED',
  SCAN_INVALID_QR = 'SCAN_INVALID_QR',
  SCAN_INVALID_ID = 'SCAN_INVALID_ID',
  SCAN_ERROR = 'SCAN_ERROR',
  SCAN_TOO_FAR = 'SCAN_TOO_FAR',
  REDEEM_NOT_6_DIGITS = 'REDEEM_NOT_6_DIGITS',
  REDEEM_INVALID_PASSWORD = 'REDEEM_INVALID_PASSWORD',
  REDEEM_FAIL = 'REDEEM_FAIL',
  REDEEM_SUCCESS = 'REDEEM_SUCCESS',
  REDEEM_ERROR = 'REDEEM_ERROR',
}
